import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
})
export class WelcomeComponent {
  @Output() accepted = new EventEmitter<void>();

  termsAccepted = false;

  onContinue(): void {
    if (this.termsAccepted) {
      this.accepted.emit();
    }
  }
}
